import api from "./api";

class NotificheManager {

    marcaComeLetta(id:number|string) {
        return api.put(`notifiche/${id}/leggi`)
    }
}

const notificheManager = new NotificheManager()

export default notificheManager
